<template>
    <button
        class="navbar__burger"
        :class="{active: isOpen, 'navbar__burger--submenu-visible': isSubmenuVisible}"
        type="button"
        aria-label="Menu"
        data-testid="navbar-burger"
        @click="$emit('click')"
    >
        <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
            <circle cx="50" cy="50" r="30" />
            <path class="line--1" d="M0 40h62c13 0 6 28-4 18L35 35" />
            <path class="line--2" d="M0 50h70" />
            <path class="line--3" d="M0 60h62c13 0 6-28-4-18L35 65" />
        </svg>
    </button>
</template>

<script setup lang="ts">
    defineProps<{isOpen?: boolean; isSubmenuVisible?: boolean}>();
    defineEmits<{click: []}>();
</script>

<style lang="scss">
    .navbar__burger {
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        background: transparent;
        width: 60px;
        height: 60px;
        overflow: hidden;
        margin-right: calc(-1 * var(--joy-core-spacing-5));

        &--submenu-visible {
            display: none;
        }

        &:focus-visible {
            outline: var(--joy-core-spacing-0) solid var(--joy-color-neutral-40);
            outline-offset: calc(-3 * var(--joy-core-spacing-0));
            border-radius: var(--joy-core-radius-4);
        }

        svg {
            display: block;
            flex-shrink: 0;
            width: 80px;
            height: 80px;
        }

        circle {
            fill: none;
        }

        path {
            fill: none;
            stroke: var(--navbar-icon-color, var(--joy-color-neutral-50));
            stroke-width: 3;
            stroke-linecap: round;
            stroke-linejoin: round;
            transition:
                stroke var(--navbar-scroll-transition-duration) var(--navbar-transition-easing),
                stroke-dasharray var(--navbar-transition-duration) var(--navbar-transition-easing),
                stroke-dashoffset var(--navbar-transition-duration) var(--navbar-transition-easing);
        }

        .line--1,
        .line--3 {
            stroke-dasharray: 24 126.64;
            stroke-dashoffset: -38;
        }

        .line--2 {
            stroke-dasharray: 24 70;
            stroke-dashoffset: -38;
        }

        &.active {
            .line--1,
            .line--3 {
                stroke-dasharray: 22.63 126.64;
                stroke-dashoffset: -94.11;
            }

            .line--2 {
                stroke-dasharray: 0 70;
                stroke-dashoffset: -50;
            }
        }
    }
</style>
